import React, { useState } from 'react';
import { X, Send } from 'lucide-react';

const ContactPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    countryCode: '+1',
    contactNumber: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Mock form submission
    alert('Thank you! We will contact you soon.');
    onClose();
    setFormData({
      fullName: '',
      email: '',
      countryCode: '+1',
      contactNumber: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose} aria-label="Close popup">
          <X size={20} />
        </button>

        <div className="popup-header">
          <h2 className="popup-title">Get Started with Your Trademark</h2>
        </div>

        <form className="popup-form" onSubmit={handleSubmit}>
          <div className="popup-form-group">
            <label className="popup-label">
              Full Name <span className="required">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter your full name"
              className="popup-input"
              required
            />
          </div>

          <div className="popup-form-group">
            <label className="popup-label">
              Email Address <span className="required">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your.email@example.com"
              className="popup-input"
              required
            />
          </div>

          <div className="popup-form-group">
            <label className="popup-label">Contact Number</label>
            <div className="popup-phone-group">
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                className="popup-country-select"
              >
                <option value="+1">+1 (US)</option>
                <option value="+44">+44 (UK)</option>
                <option value="+91">+91 (IN)</option>
                <option value="+86">+86 (CN)</option>
                <option value="+81">+81 (JP)</option>
                <option value="+49">+49 (DE)</option>
                <option value="+33">+33 (FR)</option>
                <option value="+39">+39 (IT)</option>
                <option value="+34">+34 (ES)</option>
                <option value="+7">+7 (RU)</option>
                <option value="+61">+61 (AU)</option>
                <option value="+55">+55 (BR)</option>
                <option value="+52">+52 (MX)</option>
                <option value="+27">+27 (ZA)</option>
                <option value="+82">+82 (KR)</option>
                <option value="+65">+65 (SG)</option>
                <option value="+971">+971 (AE)</option>
                <option value="+966">+966 (SA)</option>
                <option value="+31">+31 (NL)</option>
                <option value="+46">+46 (SE)</option>
              </select>
              <input
                type="tel"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="1234567890"
                className="popup-input"
                pattern="[0-9]*"
              />
            </div>
          </div>

          <div className="popup-form-group">
            <label className="popup-label">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us about your trademark needs..."
              className="popup-textarea"
              rows="2"
            />
          </div>

          <button type="submit" className="popup-submit-button">
            <Send size={18} />
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPopup;
